import { IBetslipWinboost } from "~/types/betslip/betslip-winboost";
import { calculateTotalOdds } from "~/utils/betslip/odds";

export const calculateWinBoost = (
	wager: number,
	returnAmount: number,
	winboostConfig: IBetslipWinboost | undefined,
	paymentType: 1 | 2 | 4,
	limits: { RangeFrom: number; RangeTo: number; PayoutLimit: number } | undefined
) => {
	if (paymentType === 2 || !winboostConfig || !winboostConfig.WinBoostValue) return 0;
	const odds = calculateTotalOdds(winboostConfig.bets || []);
	const potentialReturnAmount = wager * odds;
	const winBoostAmount = (potentialReturnAmount * winboostConfig.WinBoostValue) / 100;
	if (limits) {
		return winBoostAmount + returnAmount > limits.PayoutLimit ? limits.PayoutLimit - returnAmount : winBoostAmount;
	}
	return winBoostAmount;
};
